export type WorkerEnvState = {
  authToken?: string;
  // goserver's /v2 endpoints authenticate with the CMS cookie, which is a
  // different token from the chat `authToken` above.
  cmsAuthToken?: string;
  hostname?: string;
  pathname?: string;
  online?: boolean;
};

let workerEnv: WorkerEnvState = {};

export const setWorkerEnv = (update: WorkerEnvState) => {
  workerEnv = { ...workerEnv, ...update };
};

export const getWorkerAuthToken = (): string | undefined => workerEnv.authToken;
export const getWorkerCmsAuthToken = (): string | undefined => workerEnv.cmsAuthToken;
export const getWorkerHostname = (): string | undefined => workerEnv.hostname;
export const getWorkerPathname = (): string | undefined => workerEnv.pathname;
export const getWorkerOnline = (): boolean =>
  typeof workerEnv.online === 'boolean' ? workerEnv.online : true;

export const isBrowserEnv = (): boolean => typeof window !== 'undefined';
